import React, { useState, useEffect } from "react";
import {getIdData } from "../../../lib/studentinfo"
import { addData } from "../../../lib/taskm"
import { useNavigate, useParams } from 'react-router-dom';

export default function TaskManage() {

  const [subject, setSubject] = useState();
  const [desc, setDesc] = useState();
  const [studentInfo, setStudentInfo] = useState();
  const navigate = useNavigate();
  let { slug } = useParams();


  const d = new Date();
console.log("Date", new Date());

  async function GetData(id) {
    const info = await getIdData("ef400155-85c3-4512-8942-87a2bfcaf3db");
    setStudentInfo(info[0].name + " " + info[0].surname);
    console.log("Student",info);
  }

  const handleSubmit = async (e) => {
      e.preventDefault();

    if (slug === "Add") {
      console.log("Add");
      await addData({
        from:"bb780bef-49e8-4b4b-b7e3-c75d18aae7d9",
        to:"ef400155-85c3-4512-8942-87a2bfcaf3db",
        subject: subject,
        desc: desc
      });
    }
    else {
      /*
      console.log("Update");
      await updateData({
        id: slug,
        title: title,
        author: author,
        isActive: isActive
      });
      */
    }

    navigate("/admin/admin-taskmanage");
  };

  useEffect(() => {
    //navigate("/admin-params");
    if (slug === "Add") {
      GetData(slug);
    }
  }, [])
  return (
            <div className="col-xl-9 col-md-8">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>{slug === "Add" ? "Add Item" : "Update Item" }</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              To 
                            </label>
                            <h5>{studentInfo}
                              </h5>
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Subject
                            </label>
                            <input
                              type="text"
                              value={subject}
                              onChange={(e) => setSubject(e.target.value)}
                              className="form-control"
                              placeholder="Enter Subject"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">Description</label>
                            <textarea
                            rows="4"
                            onChange={(e) => setDesc(e.target.value)}
                            className="form-control"
                            placeholder="Your Description"
                            required
                          ></textarea>
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            {slug === "Add" ? "Add Item" : "Update Item" }
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
  );
}
